import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { Encrypt } from '@/utils/aes'
// 缓存相关常量
const FINGERPRINT_CACHE_KEY = 'react_device_fingerprint'
// 生成并缓存指纹
const generateAndCacheFingerprint = (info) => {
  return new Promise(async resolve => {
    const fp = await FingerprintJS.load({ monitoring: false })
    const result = await fp.get()
    if (!info.abbrName || !info.account) {
      resolve()
    }
    const aesFingerprint = Encrypt(info.abbrName + info.account + result.visitorId)
    console.log('设备指纹详情：', info, aesFingerprint)
    // 写入缓存
    localStorage.setItem(FINGERPRINT_CACHE_KEY, aesFingerprint)
    localStorage.setItem(`${FINGERPRINT_CACHE_KEY}_time`, Date.now().toString())
    resolve(aesFingerprint)
  })
}

const initFingerprint = async (info) => {
  try {
    const newFp = await generateAndCacheFingerprint(info)
    console.log(newFp)
    return newFp
  } catch (err) {
    console.error('指纹初始化失败：', err)
    return null
  }
}

export default initFingerprint
